import React, { useState } from 'react';
import { AuthenticatedLayout } from '../layouts/AuthenticatedLayout';
import { Card } from '../components/common/Card';
import { Button } from '../components/common/Button';
import { FormInput } from '../components/common/FormInput';
import { SelectInput } from '../components/common/SelectInput';

export const SettingsPage = () => {
  const [settings, setSettings] = useState({
    businessName: 'Doe Enterprises',
    currency: 'NGN',
    timezone: 'Africa/Lagos',
    language: 'en',
    theme: 'light',
  });

  const handleChange = (e) => {
    setSettings({
      ...settings,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = () => {
    // Save settings via API
    alert('Settings saved successfully!');
  };

  return (
    <AuthenticatedLayout>
      <div className="w-full max-w-2xl px-4 sm:px-6 lg:px-0">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-4 sm:mb-6">Settings</h1>

        {/* Business Settings */}
        <Card className="mb-6">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Business Information</h2>
          <FormInput
            label="Business Name"
            type="text"
            name="businessName"
            value={settings.businessName}
            onChange={handleChange}
          />
        </Card>

        {/* Regional Settings */}
        <Card className="mb-6">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Regional Settings</h2>
          <SelectInput
            label="Currency"
            name="currency"
            value={settings.currency}
            onChange={handleChange}
            options={[
              { label: 'Nigerian Naira (₦)', value: 'NGN' },
              { label: 'US Dollar ($)', value: 'USD' },
              { label: 'Euro (€)', value: 'EUR' },
            ]}
          />
          <SelectInput
            label="Timezone"
            name="timezone"
            value={settings.timezone}
            onChange={handleChange}
            options={[
              { label: 'Africa/Lagos', value: 'Africa/Lagos' },
              { label: 'UTC', value: 'UTC' },
              { label: 'Europe/London', value: 'Europe/London' },
            ]}
          />
          <SelectInput
            label="Language"
            name="language"
            value={settings.language}
            onChange={handleChange}
            options={[
              { label: 'English', value: 'en' },
              { label: 'Yoruba', value: 'yo' },
              { label: 'Igbo', value: 'ig' },
            ]}
          />
        </Card>

        {/* Appearance */}
        <Card className="mb-6">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Appearance</h2>
          <SelectInput
            label="Theme"
            name="theme"
            value={settings.theme}
            onChange={handleChange}
            options={[
              { label: 'Light', value: 'light' },
              { label: 'Dark', value: 'dark' },
              { label: 'Auto', value: 'auto' },
            ]}
          />
        </Card>

        {/* Save */}
        <Button variant="primary" onClick={handleSave}>
          Save Settings
        </Button>
      </div>
    </AuthenticatedLayout>
  );
};
